import Component from '../abstracts/Component';

export default class PdpZoomComponent extends Component {

    get SELECTORS() {
        return {
            main:'.jsThumbs',
            thumbs: '.c-m-i__thumbs__btn',
            slideVisible:'.on-view',
            pdpContainer: '.c-main-images',
            gallery: '.c-m-i__gallery',
            mouseField: '#jsZoomMouseField',
            closeBtn : '#jsCloseZoom',
            fixedBar: '#jsFixedBar',
        };
    }

    constructor() {
        super();
        this.showSlideClass= 'on-view';
        this.selectedThumbClass = 'selected-img';
        this.zoomViewClass = 'zoom-view';
        this.overlayClass = 'overlay-bar';
        this.haveFixedBar = document.querySelector(this.SELECTORS.fixedBar) != null;
    }
    hideCurrentSlide(){
        const slide = document.querySelector(this.SELECTORS.slideVisible);

        slide.classList.remove(this.showSlideClass);
    }
    showSlide(id,zoomImgsrc){
        let slide = document.getElementById(id);
        // let images = slide.getElementsByTagName('img');
        // let sources = slide.getElementsByTagName('source');
        // for (let image of images){
        //     image.src = zoomImgsrc;
        //     image.dataset.src = zoomImgsrc;
        // }
        // for (let source of sources){
        //     source.srcset = zoomImgsrc;
        // }
        let cssClass = this.showSlideClass;
        slide.classList.add(cssClass);
    }
    zoomView(bool){
        const bodyEl = document.querySelector('body');
        const cssClass = this.zoomViewClass;
        const container = document.querySelector(this.SELECTORS.pdpContainer);
        if(bool){
            bodyEl.style.overflow='hidden';
            container.classList.add(cssClass);
        }else{
            bodyEl.style.overflow='';
            container.classList.remove(cssClass);
        }
    }
    unselectAllThumbs(){
        let thumbs = document.querySelectorAll(this.SELECTORS.thumbs);
        let cssClass = this.selectedThumbClass;
        for (let thumb of thumbs){
            thumb.classList.remove(cssClass);
        }
    }
    thumbsHandler(){
        let thumbs = document.querySelectorAll(this.SELECTORS.thumbs);
        let selectedClass = this.selectedThumbClass;
        for (let thumb of thumbs){
            thumb.addEventListener('click',()=>{
                let targetId = thumb.dataset.targetImgId;
                let zoomImgsrc = thumb.dataset.imageZoomSrc;
                console.log(targetId);
                this.unselectAllThumbs();
                this.hideCurrentSlide();
                this.showSlide(targetId,zoomImgsrc);
                this.initMouseHandler(true);
                thumb.classList.add(selectedClass);
            })
        }
    }
    // throttle(callback, interval) {
    //   let enableCall = true;

    //   return function(...args) {
    //     if (!enableCall) return;

    //     enableCall = false;
    //     callback.apply(this, args);
    //     setTimeout(() => enableCall = true, interval);
    //   }
    // }
    initMouseHandler(bool){
        const fixedBar = document.querySelector(this.SELECTORS.fixedBar);
        const mouseField = document.querySelector(this.SELECTORS.mouseField);
        const gallery = document.querySelector(this.SELECTORS.gallery);
        const currentImg = document.querySelector(this.SELECTORS.slideVisible);
        let handler = (e)=>{
            let fixedBarHeight = this.haveFixedBar ? fixedBar.offsetHeight : 0;
            //Height of hidden part of image
            let hiddenHeightImg = currentImg.offsetHeight - mouseField.offsetHeight;
            //range to show the hidden part of image
            let rangeToMove = hiddenHeightImg / (mouseField.offsetHeight-fixedBarHeight);
            //total pixels to move from top
            let total = rangeToMove * this.offsetY;

            gallery.style.transform = `translate(0px,-${total}px)`;


        }
        if(bool){
            console.log('mosemove event init');
            this.intervalId = setInterval(handler, 16);
            mouseField.addEventListener('mousemove',(e)=>{
                this.offsetX = e.offsetX; //store the current mouse position so we can reference it during the interval
                this.offsetY = e.offsetY;
            });
        }else{
            console.log('mouse dead');
            this.intervalId = null;
            mouseField.removeEventListener('mousemove', mouseField);
            gallery.style.transform = `translate(0px,0px)`;
        }

    }

    overlayFixedBar(bool){
        const fixedBar = document.querySelector(this.SELECTORS.fixedBar);
        const cssClass = this.overlayClass;
        if(bool){
            fixedBar.classList.add(cssClass);
        }else{
            fixedBar.classList.remove(cssClass);
        }
    }
    galleryHandler(){
        const gallery = document.querySelector(this.SELECTORS.gallery);
        const closeBtn = document.querySelector(this.SELECTORS.closeBtn);
        let mq = window.matchMedia('(max-width:767px)');
        closeBtn.addEventListener('click',()=>{
            this.zoomView(false);
            this.haveFixedBar ? this.overlayFixedBar(false) : undefined;
            this.initMouseHandler(false);
            this.mobileGallery(gallery);
        })

        gallery.addEventListener('click',(e)=>{
            this.zoomView(true);
            this.haveFixedBar ? this.overlayFixedBar(true) : undefined;
            this.initMouseHandler(true);
            if(this.isMobile()){
                //unslick
                this.removeGallery(gallery);
            }
        });
        this.mobileGallery(gallery);

        mq.addListener((e)=>{
          if(e.matches){
            this.mobileGallery(gallery);
          }else{
            this.removeGallery(gallery);
          }
        })
    }

    mobileGallery(gallery){
        if(this.isMobile()){
            this.moduleLoader.loadCarouselAndExecute(()=>{
                $(gallery).slick({
                    dots:true,
                    arrows:false,
                    infinite:false,
                    slidesToShow:1,
                    centerMode:false,
                });
            })
        }
    }
    removeGallery(gallery){
        $(gallery).slick('unslick');
    }
    isMobile(){
        let mq = window.matchMedia('(max-width:767px)');
        let isMobile = mq.matches;
        return isMobile;
    }

    render() {
        if (document.querySelector(this.SELECTORS.main)) {
            this.thumbsHandler();
            this.galleryHandler();
        }
        let myName = this.constructor.name
        console.log(`[${myName}] Rendering..`);
    }
}
